<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <template #activator="{ on: dialog }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...dialog, ...tooltip }">
            <v-icon color="primary">mdi-qrcode</v-icon>
          </v-btn>
        </template>
        <span>Vote on mobile device</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar dense flat dark color="primary">
        <span>
          <v-icon>mdi-qrcode</v-icon>
        </span>
        <v-spacer></v-spacer>
        <span>
          Mobile Devices
        </span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-subtitle
        style="word-break: normal;"
        class="pt-10 text-center justify-center"
        >Scan QR code below using the camera on your mobile
        device.</v-card-subtitle
      >
      <v-card-title class="justify-center">
        <vue-qrious
          :size="250"
          :value="'https://app.agmify.com/live/?tk=' + $store.state.token"
        />
      </v-card-title>
    </v-card>
  </v-dialog>
</template>
<script>
import VueQrious from "vue-qrious";
export default {
  components: {
    VueQrious
  },
  data() {
    return {
      user: {},
      dialog: false
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.v-dialog {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
